<template>
  <a :href="promotion.Url" class="promotion" v-for="(promotion, index) in promotions" :key="index + promotion.Title">
    <!-- {{ promotion }} -->
    <img :src="promotion.ImageUrl" :alt="promotion.Title" />
  </a>
</template>

<script>
export default {
  name: 'PromotionComponent',
};
</script>
<script setup>
import { storeToRefs } from 'pinia';
import { onBeforeMount } from 'vue';
import { usePromotionStore } from '../stores/promotion-store';

const store = usePromotionStore();
const { promotions } = storeToRefs(store);

onBeforeMount(() => {
  store.initializePromotion();
});
</script>

<style lang="scss" scoped>
.promotion {

  img {
    width: 100%;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
  }
}
</style>
